import type { ReactNode } from 'react';
import React from 'react';

import { Box } from '@mui/material';

export const InfoBox = ({
  children,
  backgroundColor
}: {
  children?: ReactNode;
  backgroundColor?: string;
}) => {
  return (
    <Box
      sx={theme => ({
        backgroundColor: backgroundColor ?? theme.palette.secondary.main,
        color: theme.palette.text.primary,
        borderLeft: `4px solid ${theme.palette.primary.main}`
      })}
    >
      {children}
    </Box>
  );
};
